export default __webpack_public_path__ + "static/FAM0189B0X1-b55120dfd56901efc588b1c26a4d8cfa.jpg";